// iter87.212.31 — Frontend mirror of `tournament_helpers.API_FOOTBALL_NATIVE_TEMPLATES`.
// Soccer tournaments backed by the live API-Football feed — these get
// the same "detailed live score cards at top" treatment as NFL/CFB
// (see SoccerLiveTicker.jsx), not the scrolling LiveGameStrip.
export const API_FOOTBALL_TEMPLATES = new Set([
    "world_cup_api",
    "world_cup_ko_api",
    "premier_league_api",
    "la_liga_api",
    "champions_league_api",
    "epl_boost_api",
    "la_liga_boost_api",
    "club_season_api",
]);

export const isApiFootballTemplate = (template) => API_FOOTBALL_TEMPLATES.has(template);
